/* Kaddanse — mesure GA4, convention <page>_<action> (deck K18).
   Vit dans assets/ : un <script> inline dans un snippet réinjecté par le
   morph d'Horizon ne s'exécute jamais (piège documenté).
   Ne casse aucun nom d'événement existant : il n'y en avait AUCUN avant. */
(function () {
  'use strict';
  window.dataLayer = window.dataLayer || [];

  function push(name, params) {
    try {
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch (e) { /* la mesure ne casse jamais la page */ }
  }

  // Ajout panier : Horizon soumet un form /cart/add (délégué — survit au morph)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') !== -1) {
      push('produit_add_to_cart', { kdd_label: (document.title || '').slice(0, 80) });
    }
  }, true);

  // Clics : tout élément portant data-kdd-event="<page>_<action>"
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-kdd-event]');
    if (!el) return;
    push(el.getAttribute('data-kdd-event'), {
      kdd_label: (el.textContent || '').trim().slice(0, 80),
      kdd_href: el.getAttribute('href') || ''
    });
  });

  // Visibilité : sections portant data-kdd-event-view (une fois par page)
  if ('IntersectionObserver' in window) {
    var vus = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !vus.has(en.target)) {
          vus.add(en.target);
          push(en.target.getAttribute('data-kdd-event-view'));
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.4 });
    var arm = function () {
      document.querySelectorAll('[data-kdd-event-view]').forEach(function (el) { io.observe(el); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
    else arm();
    document.addEventListener('shopify:section:load', arm);
  }
})();
